import { Box, Typography } from "@mui/material";

export default function HorizonCard({
  horizon,
  count,
  avgProgress,
  statusMap,
  horizonColorMap,
  statusColorMap,
  onClick,
}) {
  const color = horizonColorMap[horizon] || "primary.main";

  const styles = {
    card: {
      bgcolor: "background.cardBackground",
      border: 1,
      borderColor: "background.tableHeader",
      borderRadius: 2,
      overflow: "hidden",
      ...(count > 0 && {
        cursor: "pointer",
        transition: "box-shadow 0.15s",
        "&:hover": { boxShadow: 4, borderColor: color },
      }),
    },
    band: { height: 4, bgcolor: color },
    body: { p: 2 },
    top: {
      display: "flex",
      justifyContent: "space-between",
      alignItems: "flex-start",
      mb: 1.25,
    },
    label: {
      fontSize: "0.75rem",
      letterSpacing: "0.12em",
      textTransform: "uppercase",
      fontWeight: 700,
      color: "background.textMuted",
      pt: 0.75,
      pr: 1,
      minWidth: 0,
      overflow: "hidden",
      textOverflow: "ellipsis",
      whiteSpace: "nowrap",
    },
    count: {
      fontSize: "2.5rem",
      fontWeight: 700,
      lineHeight: 1,
      fontVariantNumeric: "tabular-nums",
      color,
      flexShrink: 0,
    },
    progressTrack: {
      height: 4,
      bgcolor: "background.progressTrack",
      borderRadius: 0.5,
      overflow: "hidden",
      mb: 0.5,
    },
    progressFill: {
      height: "100%",
      width: `${avgProgress}%`,
      bgcolor: color,
      borderRadius: 0.5,
    },
    progressLabel: {
      fontSize: "0.75rem",
      color: "background.textMuted",
      mb: 1.5,
    },
    statusRows: {
      display: "flex",
      flexDirection: "column",
      gap: 0.75,
    },
    statusRow: {
      display: "flex",
      alignItems: "center",
      gap: 0.875,
    },
    statusLabel: {
      fontSize: "0.75rem",
      color: "background.textMuted",
      flex: 1,
      minWidth: 0,
      overflow: "hidden",
      textOverflow: "ellipsis",
      whiteSpace: "nowrap",
    },
  };

  return (
    <Box sx={styles.card} onClick={count > 0 ? onClick : undefined}>
      <Box sx={styles.band} />
      <Box sx={styles.body}>
        <Box sx={styles.top}>
          <Typography sx={styles.label}>{horizon}</Typography>
          <Typography sx={styles.count}>{count}</Typography>
        </Box>
        <Box sx={styles.progressTrack}>
          <Box sx={styles.progressFill} />
        </Box>
        <Typography sx={styles.progressLabel}>
          {avgProgress}% avg progress
        </Typography>
        <Box sx={styles.statusRows}>
          {Object.entries(statusMap).map(([status, cnt]) => {
            const dotColor = statusColorMap[status] || "primary.main";
            const dotSx = {
              width: 6,
              height: 6,
              borderRadius: "50%",
              flexShrink: 0,
              bgcolor: dotColor,
            };
            return (
              <Box key={status} sx={styles.statusRow}>
                <Box sx={dotSx} />
                <Typography sx={styles.statusLabel}>
                  {cnt} {status}
                </Typography>
              </Box>
            );
          })}
        </Box>
      </Box>
    </Box>
  );
}
